export default __webpack_public_path__ + "static/media/Biwo_Logo_Vertical.eae9e5d0.png";